import { atom } from 'recoil';

export const tokenAtom = atom({
  key: 'tokenState', // unique ID (with respect to other atoms/selectors)
  default: {
    token: null
  }
});
